import { InjectionToken } from '@angular/core';

export const PROCESSING_HISTORY_DATA = new InjectionToken<any>('Processing History Data');
export const PROCESSING_HISTORY_CALLBACK = new InjectionToken<any>('Processing History Call Back');
